import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['input'];

    inputTargetConnected(element) {
        element.style.height = 'auto';
        element.style.overflowY = 'hidden';
        element.style.height = this.getInitialScrollHeight(element) + 'px';
    }

    onInput(event) {
        event.target.style.height = 'auto';
        event.target.style.height = (event.target.scrollHeight) + 'px';
    }

    getInitialScrollHeight(element) {
        if (element.scrollHeight > 10) {
            return element.scrollHeight;
        }

        // There are situations when text area is hidden for some reason. In that case scrollHeight is always 0
        // to fix this problem we clone the input, make it hidden, add to document body and calculate height
        // if everything goes right we get real scroll height and then remove the element.
        // This operation is only necessary for initial element load and if it is hidden.
        const clone = element.cloneNode(true);
        clone.removeAttribute('data-controller');
        clone.style.position = 'absolute';
        clone.style.pointerEvents = 'none';
        clone.style.opacity = '0';
        document.body.appendChild(clone);
        const scrollHeight = clone.scrollHeight;
        clone.remove();

        return scrollHeight;
    }
}
